import React, { useState, useEffect, useCallback } from "react";
import { DatePicker, message, Button, Checkbox, Spin } from "antd";
import axios from "axios";
import moment from "moment";
import ReportStyle from "./Report.module.css";
import { DownloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const ReportComp = () => {
  const [selectedClubs, setSelectedClubs] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [events, setEvents] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [excelLink, setExcelLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingClubs, setLoadingClubs] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [allEvents, setAllEvents] = useState([]);
  const [clubsData, setClubsData] = useState([]);
  const comingsoon = false;
  const username = localStorage.getItem("name");
  const adminId = localStorage.getItem("adminId");
  const adminKey = "Bearer " + process.env.REACT_APP_ADMIN_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const userRole = localStorage.getItem("userRole");
  const [clubs] = useState(localStorage.getItem("clubIds"));

  useEffect(() => {
    if (userRole === "User") {
      const fetchEventsAndClubs = async () => {
        setLoadingClubs(true);
        setLoadingEvents(true);
        try {
          const events_local_raw = localStorage.getItem("events");
          if (!events_local_raw) {
            setLoadingEvents(false);
            setLoadingClubs(false);
            return;
          }

          const allEventsData = JSON.parse(events_local_raw);

          if (!Array.isArray(allEventsData)) {
            console.error("Events is not an array");
            setLoadingEvents(false);
            setLoadingClubs(false);
            return;
          }

          setAllEvents(allEventsData);
          console.log("allEventsData", allEventsData);
          const clubIds = Array.from(
            new Set(allEventsData.map((event) => event.club.id))
          );

          try {
            let token = localStorage.getItem("token");
            const response = await axios.post(
              `${BACKEND_URL}/admin/searchClubs`,
              {
                headers: {
                  authorization: `Bearer ${token}`
                }
              }
            );
            if (response.status === 200) {
              setClubsData(response.data);
            } else {
              console.error("Failed to fetch clubs");
            }
          } catch (e) {
            console.error("Error fetching clubs:", e);
          }
        } catch (error) {
          console.error("Error fetching events:", error);
        } finally {
          setLoadingEvents(false);
          setLoadingClubs(false);
        }
      };

      fetchEventsAndClubs();
    } else if (userRole === "Admin" || userRole === "Clubowner") {
      const fetchClubs = async () => {
        setLoadingClubs(true);
        try {
          console.log("JSON.parse(clubs)", JSON.parse(clubs));
          let token = localStorage.getItem("token");
          const response = await axios.post(
            `${BACKEND_URL}/admin/searchClubs/`,
            { clubIds: JSON.parse(clubs) },
            {
              headers: {
                authorization: `Bearer ${token}`
              }
            }
          );
          if (response.status === 200) {
            setClubsData(response.data);
          } else {
            console.error(
              "Failed to fetch clubs:",
              response.status,
              response.statusText
            );
          }
        } catch (e) {
          console.error(
            "Error fetching clubs:",
            `${BACKEND_URL}/admin/searchClubs/`,
            "\n\n\n\n\n\n",
            e.message
          );
        } finally {
          setLoadingClubs(false);
        }
      };
      const fetchAdminEvents = async () => {
        setLoadingEvents(true);
        try {
          let token = localStorage.getItem("token");
          const response = await axios.get(
            userRole === "Admin"
              ? `${BACKEND_URL}/admin/getEvents/${adminId}`
              : `${BACKEND_URL}/admin/getEventsClub/${adminId}`,
            {
              headers: {
                authorization: `Bearer ${token}`
              }
            }
          );
          if (response.status === 200) {
            const allEventsData = response.data.events;
            setAllEvents(allEventsData);
          } else {
            console.error("Failed to fetch events");
          }
        } catch (error) {
          console.error("Error fetching admin events:", error);
        } finally {
          setLoadingEvents(false);
        }
      };

      fetchClubs();
      fetchAdminEvents();
    }
  }, [userRole, adminId, adminKey, BACKEND_URL]);
  useEffect(() => {
    if (
      !allEvents.length ||
      !selectedClubs.length ||
      !dateRange[0] ||
      !dateRange[1]
    ) {
      setEvents([]);
      setSelectedEvents([]);
      return;
    }

    const [startDate, endDate] = dateRange;
    const despi = allEvents.filter((event) => {
      return selectedClubs.includes(event.club.id);
    });
    const filteredEvents = allEvents.filter((event) => {
      const eventDate = moment(event.dateAndHour).utc().startOf("day");

      // Ensure the selected start and end dates are compared using UTC and only date
      const startDateAdjusted = moment(startDate.format("YYYY-MM-DD"))
        .utc()
        .startOf("day")
        .add(1, "day");
      const endDateAdjusted = moment(endDate.format("YYYY-MM-DD"))
        .utc()
        .endOf("day")
        .add(1, "day");

      //alert(startDateAdjusted);
      //alert(startDateAdjusted);


      // Check if the event date is between the start and end dates
      const isInDateRange = eventDate.isBetween(
        startDateAdjusted,
        endDateAdjusted,
        null,
        "[]"
      );

      // Check if the event's club is selected
      const isClubSelected = selectedClubs.includes(event.club.id);
      // Return true if the event is within the date range and its club is selected
      return isInDateRange && isClubSelected;
    });


    setEvents(filteredEvents);
    setSelectedEvents(filteredEvents.map((event) => event._id));
  }, [selectedClubs, dateRange, allEvents]);

  const handleClubSelection = useCallback((clubId, isChecked) => {
    setSelectedClubs((prevSelected) => {
      let updatedSelected;
      if (isChecked) {
        // Add the club to the selected list
        updatedSelected = [...prevSelected, clubId];
      } else {
        // Remove the club from the selected list
        updatedSelected = prevSelected.filter((id) => id !== clubId);
      }
      if (updatedSelected.length === 0) {
        setDateRange([null, null]);
        setEvents([]);
        setSelectedEvents([]);
        setExcelLink("");
      }
      return updatedSelected;
    });
  }, []);

  const handleSelectAllClubs = () => {
    if (selectedClubs.length === clubsData.length) {
      setSelectedClubs([]);
    } else {
      setSelectedClubs(clubsData.map((club) => club._id));
    }
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates.length === 2) {
      setDateRange(dates);
    } else {
      setDateRange([null, null]);
    }
  };

  const handleEventSelection = (eventId) => {
    setSelectedEvents((prevSelected) =>
      prevSelected.includes(eventId)
        ? prevSelected.filter((id) => id !== eventId)
        : [...prevSelected, eventId]
    );
  };

  const handleSelectAllEvents = () => {
    if (selectedEvents.length === events.length) {
      setSelectedEvents([]);
    } else {
      setSelectedEvents(events.map((event) => event._id));
    }
  };

  const handleGenerateExcel = async () => {
    if (
      !selectedClubs.length ||
      !selectedEvents.length ||
      !dateRange[0] ||
      !adminId
    ) {
      message.error(
        "Please make sure to select clubs, events, and a date range."
      );
      return;
    }

    setLoading(true);
    try {
      const [startDate, endDate] = dateRange;
      //const formattedStartDate = new Date(dateRange[0]);
      //formattedStartDate.setDate(formattedStartDate.getDate() + 1);
      //const formattedStartDateISO = formattedStartDate.toISOString();

      //const formattedEndDate = new Date(dateRange[1]);
      //formattedEndDate.setDate(formattedEndDate.getDate() + 1);

      const startDateAdjusted = moment(startDate.format("YYYY-MM-DD"))
        .utc().startOf("day").add(1, "day");
      const endDateAdjusted = moment(endDate.format("YYYY-MM-DD"))
        .utc()
        .endOf("day").add(1, "day");

      console.log(startDateAdjusted);
      //const formattedEndDateISO = formattedEndDate.toISOString();

      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${BACKEND_URL}/admin/getoverallperformance`,
        {
          Id: adminId,
          clubIds: selectedClubs,
          eventIds: selectedEvents,
          startDate: startDateAdjusted,
          endDate: endDateAdjusted
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      console.log("sasUrl: ", response.data.sasUrl);
      setExcelLink(response.data.sasUrl);
      message.success("Excel generated successfully!");
    } catch (error) {
      message.error("Failed to generate Excel report.");
    } finally {
      setLoading(false);
    }
  };

  if (comingsoon) {
    return (
      <div className={ReportStyle.grid}>
        <h1 className={ReportStyle.title}>
          Welcome to your Report Generator Coming Soon
        </h1>
      </div>
    );
  } else {
    return (
      <div className={ReportStyle.grid}>
        <div className={ReportStyle.header}>
          <h1>Hello {username}!</h1>
          <p>Welcome back !</p>
        </div>
        <div className={ReportStyle.layout}>
          <h1>Welcome to your Report Generator</h1>

          {/* Club Selection */}
          <div>
            <h3>Select Clubs :</h3>
            {loadingClubs ? (
              <Spin />
            ) : (
              <div
                style={{
                  display: "flex",
                  overflowX: "auto", // Horizontal scroll
                  whiteSpace: "nowrap",
                  padding: "10px 0"
                }}
              >
                {clubsData.map((club) => (
                  <Checkbox
                    key={club._id}
                    checked={selectedClubs.includes(club._id)}
                    onChange={(e) =>
                      handleClubSelection(club._id, e.target.checked)
                    }
                  >
                    <div
                      style={{
                        textAlign: "center",
                        padding: "10px", // Add padding to the box
                        cursor: "pointer",
                        width: "120px" // Set a fixed width if needed
                      }}
                    >
                      <img
                        src={club.image}
                        alt={club.clubname}
                        className={ReportStyle["club-image"]}
                      />
                      <br />
                      <span className={ReportStyle["club-name"]}>
                        {club.clubname}
                      </span>
                    </div>
                  </Checkbox>
                ))}
              </div>
            )}
            <Button onClick={handleSelectAllClubs} color="danger" shape="round">
              {selectedClubs.length === clubsData.length
                ? "Unselect All Clubs"
                : "Select All Clubs"}
            </Button>
          </div>

          {/* Date Range Selection - Visible after clubs are selected */}
          {selectedClubs.length > 0 && (
            <div>
              <h3 style={{ marginTop: "20px", marginBottom: "20px" }}>
                Select Date Range :
              </h3>
              <RangePicker
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
                onChange={handleDateRangeChange}
                value={dateRange}
              />
            </div>
          )}

          {/* Event Selection - Visible after date range is selected */}
          {dateRange[0] && dateRange[1] && (
            <div>
              <h3 style={{ marginTop: "20px" }}>Select Events : </h3>
              {loadingEvents ? (
                <Spin />
              ) : (
                <div className={ReportStyle["event-container"]}>
                  {events.map((event) => {
                    const matchingClub = clubsData.find(
                      (club) => club._id === event.club.id
                    );

                    return (
                      <Checkbox
                        key={event._id}
                        checked={selectedEvents.includes(event._id)}
                        onChange={() => handleEventSelection(event._id)}
                      >
                        <div className={ReportStyle["event-item"]}>
                          {/* Event Image */}
                          <img
                            src={event.image}
                            alt={event.eventName}
                            className={ReportStyle["event-image"]}
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between"
                            }}
                          >
                            <span className={ReportStyle["event-name"]}>
                              {event.eventName}
                            </span>
                            <span className={ReportStyle["event-date"]}>
                              {moment(event.dateAndHour).format("MMM D YYYY")}
                            </span>
                          </div>

                          {/* Club Image and Name */}
                          {matchingClub && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "2px"
                              }}
                            >
                              <img
                                src={matchingClub.image}
                                alt={matchingClub.clubname}
                                className={ReportStyle["club-events"]}
                              />
                              <span>{matchingClub.clubname}</span>
                            </div>
                          )}
                        </div>
                      </Checkbox>
                    );
                  })}
                </div>
              )}
              <Button
                style={{ marginTop: "20px" }}
                onClick={handleSelectAllEvents}
                color="danger"
                shape="round"
              >
                {selectedEvents.length === events.length
                  ? "Unselect All Events"
                  : "Select All Events"}
              </Button>
            </div>
          )}

          {/* Generate Excel */}
          <div>
            <Button
              style={{ marginTop: "20px" }}
              type="primary"
              color="danger"
              onClick={handleGenerateExcel}
              format={"#F0F0F0"}
              loading={loading}
              disabled={
                !selectedClubs.length || !selectedEvents.length || !dateRange[0]
              }
            >
              Generate Excel Report
            </Button>
          </div>

          {/* Excel Link Display */}
          {excelLink && (
            <div style={{ marginTop: "20px" }}>
              <h3>Excel Report :</h3>
              {/* Link to download the Excel */}
              <Button
                icon={<DownloadOutlined />}
                href={excelLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  marginTop: "10px",
                  backgroundColor: "green",
                  borderColor: "green",
                  color: "white",
                  textDecoration: "none" // Removes underline
                }}
              >
                Download Excel
              </Button>

              {/* Embed Excel in iframe */}
              <h3 style={{ marginTop: "20px" }}>View Excel in Browser:</h3>
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(excelLink)}`}
                width="100%"
                height="600px"
                frameBorder="0"
                title="Excel Report"
              ></iframe>
            </div>
          )}
        </div>
      </div>
    );
  }
};

export default ReportComp;
